import React from "react";
import BioMedicalWasteFormPage from "../components/bio-medical-waste/BioMedicalWasteFormPage";

const BioMedicalWasteEdit = () => <BioMedicalWasteFormPage mode="edit" />;

export default BioMedicalWasteEdit;

